export const totalsCombine = (a, b) => {
    return {
        'nontaxable_full': a.nontaxable_full + b.nontaxable,
        'taxable_full': a.taxable_full + b.taxable,
        'subtotal_full': a.subtotal_full + b.subtotal,
    };
};
export const totalsCombineSameRate = (a, b) => {
    if (b.rate !== a.rate) {
        throw `totalsCombineSameRate - mismatched rates: ${a.rate} ${b.rate}`;
    }
    return {
        'rate': a.rate,
        'nontaxable': a.nontaxable + b.nontaxable,
        'taxable': a.taxable + b.taxable,
        'subtotal': a.subtotal + b.subtotal,
    };
};
